import type { FunctionComponent } from 'react';
import { useEffect } from 'react';
import { Box, CircularProgress } from '@mui/material';
import moment from 'moment';

export const getTimeDifference = (StartTime: string, EndTime: string) => {
  const startDate = moment(StartTime, 'YYYY-MM-DDTHH:mm:ss');
  const endDate = moment(EndTime, 'YYYY-MM-DDTHH:mm:ss');
  const duration = moment.duration(endDate.diff(startDate));
  return duration;
};

const ZoomCallEnd: FunctionComponent = () => {
  useEffect(() => {
    localStorage.setItem('refresh-consult-tabs', Date.now().toString());
    sessionStorage.setItem('errorFlag', 'false');

    // Small delay to ensure localStorage is accessible before navigation
    const timer = setTimeout(() => {
      const returnUrl = localStorage.getItem('zoom-return-url');
      console.log('return url from zoom end', returnUrl);
      if (returnUrl) {
        localStorage.removeItem('zoom-return-url');
        globalThis.location.replace(returnUrl);
      } else {
        // Fallback: navigate to home if no return URL is saved
        globalThis.location.replace('/');
        window.close();
        globalThis.close();
        return null;
      }
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Box id="zoomCallEndContainer" className="Zoom-circular-Progress">
      <CircularProgress />
    </Box>
  );
};

export default ZoomCallEnd;
